import * as React from 'react'
import IconButton from 'material-ui/IconButton'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back'

export function MenuAndUpButton({onMenuButtonClicked, onUpButtonClicked, upUrl}: {
    onMenuButtonClicked: React.MouseEventHandler<{}>
    onUpButtonClicked?: React.MouseEventHandler<{}>
    upUrl: string,
}) {
    return (
        <div>
            <IconButton
                onClick={onMenuButtonClicked}
            >
                <NavigationMenu color="#ffffff"/>
            </IconButton>
            <IconButton
                href={upUrl}
                style={{marginTop: '-16px'}}
                onClick={onUpButtonClicked}
            >
                <NavigationArrowBack color="#ffffff"/>
            </IconButton>
        </div>)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/MenuAndUpButton.tsx